'use client';
import { GetSettings } from "@/action/action";
import Head from "next/head";
import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import Footer from "../containers/Footer";
import './policy.style.css';
import HeaderPages from "../containers/HeaderPages";

const PolicyPage = () => {
  const searchParams = useSearchParams();
  const policy = searchParams.get("policy"); 

  const [data, setData] = useState([]);

  useEffect(() => {
    GetSettings({
      callback: (res) => {
        console.log("res", res);
        if (res) {
          setData(res);
        }
      },
    });
  }, []);


  const content =
    policy === "privacy-policy" ? (
      <div dangerouslySetInnerHTML={{ __html: data?.privacy_policy }} />
    ) : policy === "terms-and-conditions" ? (
      <div dangerouslySetInnerHTML={{ __html: data?.terms_and_conditions }} />
    ) : null;

  return (
    <>
      <Head>
        <title>Sagio</title>
        <link rel="icon" href="../favicon.ico" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Head>


      <div className="policyWrapper">
      <HeaderPages/>
        <div className="policy-container">
          <h1>
            {policy === "privacy-policy"
              ? "Privacy Policy"
              : policy === "terms-and-conditions"
              ? "Terms and Conditions"
              : "Privacy Policy"}
          </h1>
          {content}
        </div>
        <Footer className="footerPolicy" />
      </div>
     
    </>
  );
};

export default PolicyPage;
